import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream px-5 pb-28 pt-10 text-center sm:px-6 sm:pb-32" data-id="element-107" data-mp="32wd2qgad7ltj">
      <p className="font-display text-lg font-bold text-ofm-900" data-id="element-108" data-mp="3gg0xbxz0nnv0">Dra. Karito</p>
      <p className="mt-1 text-[13px] font-semibold text-ofm-800/70" data-id="element-109" data-mp="32onl753ftsa0">
        Sistema de Decisión Clínica OFM
      </p>

      <nav aria-label="Enlaces legales" className="mx-auto mt-4 flex max-w-md flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[12px] text-ofm-800/60" data-id="element-110" data-mp="36pzblcu4yhj9">
        <a href="https://www.drakarito.com" className="hover:text-ofm-700" data-id="element-111" data-mp="37o6qw57hzdw">
          www.drakarito.com
        </a>
        <span aria-hidden="true" data-id="element-112" data-mp="3ldu3ir0bkhva">·</span>
        <a href="#" className="hover:text-ofm-700" data-id="element-113" data-mp="3qdf3n4r86w9l">
          Términos y Condiciones
        </a>
        <span aria-hidden="true" data-id="element-114" data-mp="29z6v4e3aingy">·</span>
        <a href="#" className="hover:text-ofm-700" data-id="element-115" data-mp="29y5fdwbbxcsw">
          Política de Privacidad
        </a>
        <span aria-hidden="true" data-id="element-116" data-mp="2ezbag0sgpc5l">·</span>
        <a href="#" className="hover:text-ofm-700" data-id="element-117" data-mp="2ew70snw89o7j">
          Contacto
        </a>
      </nav>

      <p className="mt-5 text-[11px] text-ofm-800/50" data-id="element-118" data-mp="3lbmttrbgd6fd">
        © 2026 Dra. Karito — Todos los derechos reservados.
      </p>
    </footer>;
}